import React from 'react';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import { CustomSwitch } from '../../svg/UtilsIcons';

const TemplateDashboardEditControls = ({
    edit,
    webDashboardT,
    isMultiSelectEnabled,
    handleMultiSelectDashboardToggle,
    isMultiSelectToggleReady,
    isCurrentDashboardFixedWidth,
    handleFixedWidthDashboardToggle,
    isFixedWidthToggleReady,
    isDashboardExpandedActive,
    setIsDashboardExpanded,
    dashboardExpandLabel,
}) => (
    <>
        {edit.mode === 'edit' ? (
            <div className="template-fixed-width-toggle">
                <span className="template-fixed-width-toggle-label">
                    {webDashboardT.multiSelectWidgets || 'Multi Select'}
                </span>
                <CustomSwitch
                    checked={isMultiSelectEnabled}
                    onChange={handleMultiSelectDashboardToggle}
                    disabled={!isMultiSelectToggleReady}
                />
                <span className="template-fixed-width-toggle-label">
                    {webDashboardT.fixedWidthDashboard || 'Fixed Width Dashboard'}
                </span>
                <CustomSwitch
                    checked={isCurrentDashboardFixedWidth}
                    onChange={handleFixedWidthDashboardToggle}
                    disabled={!isFixedWidthToggleReady}
                />
            </div>
        ) : null}
        <div className="dashboard-edit-expand-actions">
            <button
                type="button"
                className={`dashboard-edit-expand-toggle${isDashboardExpandedActive ? ' active' : ''}`}
                onClick={() => setIsDashboardExpanded((prev) => !prev)}
                title={dashboardExpandLabel}
                aria-label={dashboardExpandLabel}
            >
                {isDashboardExpandedActive ? (
                    <CloseFullscreenIcon className="dashboard-edit-expand-toggle-icon" />
                ) : (
                    <OpenInFullIcon className="dashboard-edit-expand-toggle-icon" />
                )}
                <span className="dashboard-edit-expand-toggle-label">
                    {dashboardExpandLabel}
                </span>
            </button>
        </div>
    </>
);

export default TemplateDashboardEditControls;
